import requestActionFactory from 'common/actions/requestActionFactory';
import DataV2 from 'common/DataV2';

import type { IdeasConfiguration } from 'common/api/endpoints/idea';
import type { Dispatch, GetState, State } from 'redux-connect';

export { defaultState } from 'common/reducers/requestReducerFactory';

// Action Types

const {
  requestAction: fieldsRequested,
  loadedAction: fieldsLoaded,
  errorAction: fieldsError,

  RequestType,
  LoadedType,
  ErrorType,
} = requestActionFactory<IdeasConfiguration>('ideasConfiguration');

export { RequestType, LoadedType, ErrorType };

// Action Creators

function fetchConfiguration() {
  return async (dispatch: Dispatch, getState: GetState) => {
    const cookies = getState().cookies;
    try {
      const response = await DataV2.fetch(DataV2.queries.ideasConfiguration, {}, cookies);
      return dispatch(fieldsLoaded(response.items));
    } catch (error) {
      if (typeof error === 'string') {
        return dispatch(fieldsError(error));
      }
      return dispatch(fieldsError('server error'));
    }
  };
}

export function loadConfiguration() {
  return (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    if (shouldFetch(state)) {
      dispatch(fieldsRequested());
      return dispatch(fetchConfiguration());
    }
  };
}

export function reloadConfiguration() {
  return (dispatch: Dispatch) => {
    return dispatch(fetchConfiguration());
  };
}

// Helpers

export function shouldFetch(state: State) {
  return !state.ideasConfiguration.data && !state.ideasConfiguration.error;
}
